















































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import CustomTemplate from '@/pages/Pages/Templates/CustomTemplate.vue'
import { MsgTransports } from '@/store/types';
import { SelectWings } from "wings-ui-components";

@Component({components: {GenericDistribution, CustomTemplate, SelectWings}})
export default class CustomDistribution extends GenericDistribution {

  transport = MsgTransports.CUSTOM

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
